// Centralized enum for form UI component types used in WorkFlowBuilder

export enum FormUiComponentType {
  Text = 'text',
  Number = 'number',
  Boolean = 'boolean',
  Dropdown = 'dropdown',
  JsonArray = 'jsonArray',
  BackendSearch = 'backend_search',
  // Backward compatibility only: older data of JsonArray inner fields used 'string'.
  // For all new definitions, use 'text' instead of 'string'.
  String = 'string',
}

// Enum for object builder metadata field dataType
export enum ObjectFieldDataType {
  Boolean = 'boolean',
  Number = 'number',
  String = 'string',
  Enum = 'enum',
  JsonArray = 'jsonArray',
  Datetime = 'datetime',
  Hyperlink = 'hyperlink',
}
